<template>
	<div class="slidePage3">
        <div class="title">
            <img src="@/assets/slide3_title_icon.png" alt="">
            <span>移动物联网+人工智能技术的端到端智慧居家养老系统</span>
        </div>
        <el-carousel class="slidePageCarousel" :interval="4000" :autoplay="false" type="card" height="85%">
            <el-carousel-item >
                <div class="item">
                    <img class="img" src="@/assets/page3-1.png" alt="" />
                </div>
                <span class="item-title">多级预警/报警反馈机制</span>
            </el-carousel-item>
            <el-carousel-item >
                <div class="item">
                    <img class="img" src="@/assets/page3-2.png" alt="" />
                </div>
                <span class="item-title">养老数据应用能力</span>
            </el-carousel-item>
            <el-carousel-item >
                <div class="item">
                    <img class="img" src="@/assets/page3-3.png" alt="" />
                </div>
                <span class="item-title">基于AIOT设备生态  快速布置安全监测设备</span>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
	name: 'SlidePage3',
}
</script>

<style lang="scss" scoped>
.slidePage3 {
	width: 100%;
	height: 100%;
	background: url('../assets/slide3_bg.png');
	background-size: 100% 100%;
    overflow: hidden;
    ::v-deep .el-carousel__indicators--outside button{
        width: 14px;
        height: 14px;
        background: #fff;
        opacity: 1;
        border-radius: 50%;
    }
    ::v-deep .el-carousel__indicator.is-active button{
        background: #8CFF94;
    }
    .title{
        margin: 2% 0 1.6% 0;
        display: flex;
        justify-content: center;
        align-items: center;
        span{
            font-size: 40px;
            font-weight: 500;
            color: #333333;
            margin-left: 23px;
        }
    }
    .slidePageCarousel{
        height: 90%;
        // background: brown;
        .item{
            width: 100%;
            height: 85%;
            background: #fff;
            position: relative;
            box-shadow: 4px 10px 12px 0px rgba(41, 164, 88, 0.19);
            margin-bottom: 34px;
            border-radius: 4px;
            img{
                position: absolute;
                top:50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
        .item-title{
            font-size: 24px;
            font-weight: 500;
            color: #333333;
        }
    }
}
</style>
